import React from "react"
import badge from "badges/third-column-badge-blocked.svg"
import { BadgeImage } from "backpack/badges/styled"

const ThirdColumnBadgeBlocked = props => <BadgeImage src={badge} {...props} />

export default ThirdColumnBadgeBlocked
